// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CurieAISidebar-module__font-s-10___bqfho {
  font-size: 10px !important;
}

.CurieAISidebar-module__font-s-12___mNUW0 {
  font-size: 12px !important;
}

.CurieAISidebar-module__font-s-13___CrOpK {
  font-size: 13px !important;
}

.CurieAISidebar-module__font-s-14___QcG3Z {
  font-size: 14px !important;
}

.CurieAISidebar-module__font-s-15___AvbMk {
  font-size: 15px !important;
}

.CurieAISidebar-module__font-s-16___m_FQm {
  font-size: 16px !important;
}

.CurieAISidebar-module__font-s-18___JgFBf {
  font-size: 18px !important;
}

.CurieAISidebar-module__font-s-20___MfqUS {
  font-size: 20px !important;
}

.CurieAISidebar-module__font-s-22___FbOac {
  font-size: 22px !important;
}

.CurieAISidebar-module__font-s-28___io18t {
  font-size: 28px !important;
}

.CurieAISidebar-module__font-w-400___zO_LJ {
  font-weight: 400 !important;
}

.CurieAISidebar-module__font-w-500___JSSYA {
  font-weight: 500 !important;
}

.CurieAISidebar-module__font-w-600___Vlvq0 {
  font-weight: 600 !important;
}

.CurieAISidebar-module__font-w-700___WgmeV {
  font-weight: 700 !important;
}

.CurieAISidebar-module__p-5___TN7K7 {
  padding: 5px !important;
}

.CurieAISidebar-module__p-12___jP6jS {
  padding: 12px !important;
}

.CurieAISidebar-module__p-16___N6S2_ {
  padding: 16px !important;
}

.CurieAISidebar-module__p-30___F0Qsb {
  padding: 30px !important;
}

.CurieAISidebar-module__p-b-0___etwxw {
  padding-bottom: 0 !important;
}

.CurieAISidebar-module__p-b-5___rkCMR {
  padding-bottom: 5px !important;
}

.CurieAISidebar-module__p-b-10___dQpo8 {
  padding-bottom: 10px !important;
}

.CurieAISidebar-module__p-b-12___BaRxp {
  padding-bottom: 12px !important;
}

.CurieAISidebar-module__p-b-16___GMVKQ {
  padding-bottom: 16px !important;
}

.CurieAISidebar-module__p-b-18___kHr20 {
  padding-bottom: 18px !important;
}

.CurieAISidebar-module__p-b-20___rsrSJ {
  padding-bottom: 20px !important;
}

.CurieAISidebar-module__p-b-25___Di5Xl {
  padding-bottom: 25px !important;
}

.CurieAISidebar-module__p-b-30___3qkFV {
  padding-bottom: 30px !important;
}

.CurieAISidebar-module__p-b-50___dVDYT {
  padding-bottom: 50px !important;
}

.CurieAISidebar-module__p-t-0___EYrW7 {
  padding-top: 0 !important;
}

.CurieAISidebar-module__p-t-12___pPMLw {
  padding-top: 12px !important;
}

.CurieAISidebar-module__p-t-16___pGDSm {
  padding-top: 16px !important;
}

.CurieAISidebar-module__p-t-18___ARMZk {
  padding-top: 18px !important;
}

.CurieAISidebar-module__p-t-20____cJLr {
  padding-top: 20px !important;
}

.CurieAISidebar-module__p-t-30___MfC5G {
  padding-top: 30px !important;
}

.CurieAISidebar-module__p-t-40___pwYS1 {
  padding-top: 40px !important;
}

.CurieAISidebar-module__p-t-50___FoFwt {
  padding-top: 50px !important;
}

.CurieAISidebar-module__p-l-20___mlXw6 {
  padding-left: 20px !important;
}

.CurieAISidebar-module__p-l-30___no1xY {
  padding-left: 30px !important;
}

.CurieAISidebar-module__p-l-40___XwJu9 {
  padding-left: 40px !important;
}

.CurieAISidebar-module__p-r-16___ixaBX {
  padding-right: 16px !important;
}

.CurieAISidebar-module__p-r-20___IwV_n {
  padding-right: 20px !important;
}

.CurieAISidebar-module__p-r-30___oNBqB {
  padding-right: 30px !important;
}

.CurieAISidebar-module__p-r-50___1ZmHj {
  padding-right: 50px !important;
}

.CurieAISidebar-module__p-r-60___P2mNN {
  padding-right: 60px !important;
}

.CurieAISidebar-module__m-b-1___IeBbz {
  margin-bottom: 1px !important;
}

.CurieAISidebar-module__m-b-2___Sc0Jg {
  margin-bottom: 2px !important;
}

.CurieAISidebar-module__m-b-6___obfxU {
  margin-bottom: 6px !important;
}

.CurieAISidebar-module__m-b-8___ovnWA {
  margin-bottom: 8px !important;
}

.CurieAISidebar-module__m-b-10___VM6N6 {
  margin-bottom: 10px !important;
}

.CurieAISidebar-module__m-b-14___riZ8u {
  margin-bottom: 14px !important;
}

.CurieAISidebar-module__m-b-16___xeQjf {
  margin-bottom: 16px !important;
}

.CurieAISidebar-module__m-b-20___P7BXe {
  margin-bottom: 20px !important;
}

.CurieAISidebar-module__m-b-22___ZY6zL {
  margin-bottom: 22px !important;
}

.CurieAISidebar-module__m-b-24___OQbcP {
  margin-bottom: 24px !important;
}

.CurieAISidebar-module__m-b-30___fIYUL {
  margin-bottom: 30px !important;
}

.CurieAISidebar-module__m-b-32___Yy51L {
  margin-bottom: 32px !important;
}

.CurieAISidebar-module__m-b-40___QOmuP {
  margin-bottom: 40px !important;
}

.CurieAISidebar-module__m-t-2___X3YHd {
  margin-top: 2px !important;
}

.CurieAISidebar-module__m-t-3___AtPbr {
  margin-top: 3px !important;
}

.CurieAISidebar-module__m-t-4___dzoE4 {
  margin-top: 4px !important;
}

.CurieAISidebar-module__m-t-5___PBhml {
  margin-top: 5px !important;
}

.CurieAISidebar-module__m-t-8___nZT9I {
  margin-top: 8px !important;
}

.CurieAISidebar-module__m-t-10___x3Mxp {
  margin-top: 10px !important;
}

.CurieAISidebar-module__m-t-15___gOJc2 {
  margin-top: 15px !important;
}

.CurieAISidebar-module__m-t-16___s_ksB {
  margin-top: 16px !important;
}

.CurieAISidebar-module__m-t-20___OpPUq {
  margin-top: 20px !important;
}

.CurieAISidebar-module__m-t-22___YKn3b {
  margin-top: 22px !important;
}

.CurieAISidebar-module__m-t-30___r_s96 {
  margin-top: 30px !important;
}

.CurieAISidebar-module__m-t-32___U8oDK {
  margin-top: 32px !important;
}

.CurieAISidebar-module__m-l-auto___xwSeC {
  margin-left: auto !important;
}

.CurieAISidebar-module__m-l-4___kDvBo {
  margin-left: 4px !important;
}

.CurieAISidebar-module__m-l-5___akXc1 {
  margin-left: 5px !important;
}

.CurieAISidebar-module__m-l-6___BwQg5 {
  margin-left: 6px !important;
}

.CurieAISidebar-module__m-l-8___N3I5X {
  margin-left: 8px !important;
}

.CurieAISidebar-module__m-l-10___mOx2D {
  margin-left: 10px !important;
}

.CurieAISidebar-module__m-l-16___Fem2L {
  margin-left: 16px !important;
}

.CurieAISidebar-module__m-l-20___a8SOQ {
  margin-left: 20px !important;
}

.CurieAISidebar-module__m-l-24___NqrtV {
  margin-left: 24px !important;
}

.CurieAISidebar-module__m-l-30___t6Gql {
  margin-left: 30px !important;
}

.CurieAISidebar-module__m-l-35___ZEVE8 {
  margin-left: 35px !important;
}

.CurieAISidebar-module__m-l-40___r1rsh {
  margin-left: 40px !important;
}

.CurieAISidebar-module__m-r-8___VeE78 {
  margin-right: 8px !important;
}

.CurieAISidebar-module__m-r-10___xKDgo {
  margin-right: 10px !important;
}

.CurieAISidebar-module__m-r-16___JC6GZ {
  margin-right: 16px !important;
}

.CurieAISidebar-module__m-r-20___GJrz2 {
  margin-right: 20px !important;
}

.CurieAISidebar-module__m-r-24___zkCw5 {
  margin-right: 24px !important;
}

.CurieAISidebar-module__m-r-30___urNoF {
  margin-right: 30px !important;
}

.CurieAISidebar-module__m-r-40___AgcSR {
  margin-right: 40px !important;
}

.CurieAISidebar-module__border-r-3___uvwen {
  border-radius: 3px !important;
}

.CurieAISidebar-module__border-r-4___dSFWv {
  border-radius: 4px !important;
}

.CurieAISidebar-module__border-r-6___PlzZL {
  border-radius: 6px !important;
}

.CurieAISidebar-module__border-r-10___FiRV8 {
  border-radius: 10px !important;
}

.CurieAISidebar-module__border-r-12___Jg3g4 {
  border-radius: 12px !important;
}

.CurieAISidebar-module__border-r-16___YKLzh {
  border-radius: 16px !important;
}

.CurieAISidebar-module__border-r-50___xC5wo {
  border-radius: 50% !important;
}

.CurieAISidebar-module__primary-border___m0FAA {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.CurieAISidebar-module__primary-border-b___wRliW {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.CurieAISidebar-module__primary-border-t___dJt1s {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.CurieAISidebar-module__primary-border-l___RofYa {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.CurieAISidebar-module__primary-border-r___MM_cW {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.CurieAISidebar-module__secondary-border___OK7ki {
  border: 1px solid #637768;
}

.CurieAISidebar-module__secondary-border-b___NUOhz {
  border-bottom: 1px solid #637768;
}

.CurieAISidebar-module__secondary-border-t___l0hAx {
  border-top: 1px solid #637768;
}

.CurieAISidebar-module__secondary-border-l___kG3BZ {
  border-left: 1px solid #637768;
}

.CurieAISidebar-module__secondary-border-r___VTWxj {
  border-right: 1px solid #637768;
}

.CurieAISidebar-module__gap-0___nbaTc {
  gap: 0 !important;
}

.CurieAISidebar-module__gap-2___CfNj_ {
  gap: 2px !important;
}

.CurieAISidebar-module__gap-4___UOeep {
  gap: 4px !important;
}

.CurieAISidebar-module__gap-5___E_YOV {
  gap: 5px !important;
}

.CurieAISidebar-module__gap-6___Y6c89 {
  gap: 6px !important;
}

.CurieAISidebar-module__gap-8___FCHvA {
  gap: 8px !important;
}

.CurieAISidebar-module__gap-10___UnwAn {
  gap: 10px !important;
}

.CurieAISidebar-module__gap-12___hZZIL {
  gap: 12px !important;
}

.CurieAISidebar-module__gap-14___nrGsS {
  gap: 14px !important;
}

.CurieAISidebar-module__gap-16___EsIV1 {
  gap: 16px !important;
}

.CurieAISidebar-module__gap-18___Qf2gl {
  gap: 18px !important;
}

.CurieAISidebar-module__gap-20___wlP4y {
  gap: 20px !important;
}

.CurieAISidebar-module__gap-24___KtuPX {
  gap: 24px !important;
}

.CurieAISidebar-module__gap-26___s7Okk {
  gap: 26px !important;
}

.CurieAISidebar-module__gap-30___NmNJ4 {
  gap: 30px !important;
}

.CurieAISidebar-module__gap-32___ZbmKU {
  gap: 32px !important;
}

.CurieAISidebar-module__gap-40___ufcG5 {
  gap: 40px !important;
}

.CurieAISidebar-module__gap-50___QKt72 {
  gap: 50px !important;
}

.CurieAISidebar-module__flex-1___jDZxh {
  flex: 1;
}

.CurieAISidebar-module__flex-none___osX74 {
  flex: none !important;
}

.CurieAISidebar-module__flex-column___dBWky {
  display: flex;
  flex-direction: column !important;
}

.CurieAISidebar-module__flex-row___McZUe {
  display: flex;
  flex-direction: row !important;
}

.CurieAISidebar-module__vertically-centered___H9foy {
  display: flex;
  align-items: center !important;
}

.CurieAISidebar-module__horizontally-centered___swSuJ {
  display: flex;
  justify-content: center !important;
}

.CurieAISidebar-module__horizontally-end___nBKhE {
  display: flex;
  justify-content: end !important;
}

.CurieAISidebar-module__vertically-start___gPT7d {
  display: flex;
  align-items: start !important;
}

.CurieAISidebar-module__space-between___RJvQz {
  display: flex;
  justify-content: space-between !important;
}

.CurieAISidebar-module__flex-wrap___LHZQZ {
  flex-wrap: wrap !important;
}

.CurieAISidebar-module__height-100___rKLtA {
  height: 100%;
}

.CurieAISidebar-module__width-50___Jmo2g {
  width: 50% !important;
}

.CurieAISidebar-module__width-100___QIX4U {
  width: 100%;
}

.CurieAISidebar-module__cursor-pointer___r0QGH {
  cursor: pointer;
}

.CurieAISidebar-module__cursor-not-allowed___Ax9gl {
  cursor: not-allowed !important;
}

.CurieAISidebar-module__absolute-centered___XlHY0 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.CurieAISidebar-module__absolute___imaRQ {
  position: absolute;
}

.CurieAISidebar-module__relative___ZlVBu {
  position: relative;
}

.CurieAISidebar-module__fixed___KDtzL {
  position: fixed;
}

.CurieAISidebar-module__visible___WOftn {
  opacity: 1;
}

.CurieAISidebar-module__invisible___J_vbO {
  opacity: 0;
}

.CurieAISidebar-module__col-90___Fm6PC {
  width: 90% !important;
}

.CurieAISidebar-module__col-auto___R7iO8 {
  width: auto !important;
}

.CurieAISidebar-module__medical-tabs___r70k5 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.CurieAISidebar-module__medical-table-new___qCxlq {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CurieAISidebar-module__medical-table-new___qCxlq:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CurieAISidebar-module__medical-table-new___qCxlq::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CurieAISidebar-module__medical-table-new___qCxlq::-webkit-scrollbar-track {
  display: none;
}
.CurieAISidebar-module__medical-table-new___qCxlq.CurieAISidebar-module__no-pagination___G7dsH {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CurieAISidebar-module__medical-table-new___qCxlq.CurieAISidebar-module__no-pagination___G7dsH:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CurieAISidebar-module__medical-table-new___qCxlq.CurieAISidebar-module__no-pagination___G7dsH::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CurieAISidebar-module__medical-table-new___qCxlq.CurieAISidebar-module__no-pagination___G7dsH::-webkit-scrollbar-track {
  display: none;
}

.CurieAISidebar-module__medical-table-empty___WxUv9 {
  padding: 14px 40px !important;
}

.CurieAISidebar-module__icon-btn___JPL23 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.CurieAISidebar-module__search-icon___bLXLh {
  width: 24px;
  height: 24px;
  align-self: center;
}

.CurieAISidebar-module__disable-select___zyVR5 {
  user-select: none;
}

.CurieAISidebar-module__break-word___PaUCK {
  word-break: break-word;
}

.CurieAISidebar-module__popup-clear-btn___m6xzw {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.CurieAISidebar-module__scroll-m-b-20___oIOO_ {
  scroll-margin-bottom: 20px;
}

.CurieAISidebar-module__list___A0YMo {
  width: calc(100% - 15px);
  padding-right: 5px;
  margin: 10px;
}

.CurieAISidebar-module__emptyText___Dt0iu {
  width: 100%;
}
.CurieAISidebar-module__emptyText___Dt0iu > span {
  color: #637768;
  align-self: flex-start;
  margin: 15px 25px;
  font-size: 14px;
  font-weight: 500;
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/CurieAISidebar/CurieAISidebar.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,wBAAA;EACA,kBAAA;EACA,YAAA;AA8pBF;;AA3pBA;EACE,WAAA;AA8pBF;AA5pBE;EACE,cAAA;EACA,sBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AA8pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.list {\n  width: calc(100% - 15px);\n  padding-right: 5px;\n  margin: 10px;\n}\n\n.emptyText {\n  width: 100%;\n\n  & > span {\n    color: get-color(greenNew, medium-dark);\n    align-self: flex-start;\n    margin: 15px 25px;\n    font-size: 14px;\n    font-weight: 500;\n    font-style: italic;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `CurieAISidebar-module__font-s-10___bqfho`,
	"fontS12": `CurieAISidebar-module__font-s-12___mNUW0`,
	"fontS13": `CurieAISidebar-module__font-s-13___CrOpK`,
	"fontS14": `CurieAISidebar-module__font-s-14___QcG3Z`,
	"fontS15": `CurieAISidebar-module__font-s-15___AvbMk`,
	"fontS16": `CurieAISidebar-module__font-s-16___m_FQm`,
	"fontS18": `CurieAISidebar-module__font-s-18___JgFBf`,
	"fontS20": `CurieAISidebar-module__font-s-20___MfqUS`,
	"fontS22": `CurieAISidebar-module__font-s-22___FbOac`,
	"fontS28": `CurieAISidebar-module__font-s-28___io18t`,
	"fontW400": `CurieAISidebar-module__font-w-400___zO_LJ`,
	"fontW500": `CurieAISidebar-module__font-w-500___JSSYA`,
	"fontW600": `CurieAISidebar-module__font-w-600___Vlvq0`,
	"fontW700": `CurieAISidebar-module__font-w-700___WgmeV`,
	"p5": `CurieAISidebar-module__p-5___TN7K7`,
	"p12": `CurieAISidebar-module__p-12___jP6jS`,
	"p16": `CurieAISidebar-module__p-16___N6S2_`,
	"p30": `CurieAISidebar-module__p-30___F0Qsb`,
	"pB0": `CurieAISidebar-module__p-b-0___etwxw`,
	"pB5": `CurieAISidebar-module__p-b-5___rkCMR`,
	"pB10": `CurieAISidebar-module__p-b-10___dQpo8`,
	"pB12": `CurieAISidebar-module__p-b-12___BaRxp`,
	"pB16": `CurieAISidebar-module__p-b-16___GMVKQ`,
	"pB18": `CurieAISidebar-module__p-b-18___kHr20`,
	"pB20": `CurieAISidebar-module__p-b-20___rsrSJ`,
	"pB25": `CurieAISidebar-module__p-b-25___Di5Xl`,
	"pB30": `CurieAISidebar-module__p-b-30___3qkFV`,
	"pB50": `CurieAISidebar-module__p-b-50___dVDYT`,
	"pT0": `CurieAISidebar-module__p-t-0___EYrW7`,
	"pT12": `CurieAISidebar-module__p-t-12___pPMLw`,
	"pT16": `CurieAISidebar-module__p-t-16___pGDSm`,
	"pT18": `CurieAISidebar-module__p-t-18___ARMZk`,
	"pT20": `CurieAISidebar-module__p-t-20____cJLr`,
	"pT30": `CurieAISidebar-module__p-t-30___MfC5G`,
	"pT40": `CurieAISidebar-module__p-t-40___pwYS1`,
	"pT50": `CurieAISidebar-module__p-t-50___FoFwt`,
	"pL20": `CurieAISidebar-module__p-l-20___mlXw6`,
	"pL30": `CurieAISidebar-module__p-l-30___no1xY`,
	"pL40": `CurieAISidebar-module__p-l-40___XwJu9`,
	"pR16": `CurieAISidebar-module__p-r-16___ixaBX`,
	"pR20": `CurieAISidebar-module__p-r-20___IwV_n`,
	"pR30": `CurieAISidebar-module__p-r-30___oNBqB`,
	"pR50": `CurieAISidebar-module__p-r-50___1ZmHj`,
	"pR60": `CurieAISidebar-module__p-r-60___P2mNN`,
	"mB1": `CurieAISidebar-module__m-b-1___IeBbz`,
	"mB2": `CurieAISidebar-module__m-b-2___Sc0Jg`,
	"mB6": `CurieAISidebar-module__m-b-6___obfxU`,
	"mB8": `CurieAISidebar-module__m-b-8___ovnWA`,
	"mB10": `CurieAISidebar-module__m-b-10___VM6N6`,
	"mB14": `CurieAISidebar-module__m-b-14___riZ8u`,
	"mB16": `CurieAISidebar-module__m-b-16___xeQjf`,
	"mB20": `CurieAISidebar-module__m-b-20___P7BXe`,
	"mB22": `CurieAISidebar-module__m-b-22___ZY6zL`,
	"mB24": `CurieAISidebar-module__m-b-24___OQbcP`,
	"mB30": `CurieAISidebar-module__m-b-30___fIYUL`,
	"mB32": `CurieAISidebar-module__m-b-32___Yy51L`,
	"mB40": `CurieAISidebar-module__m-b-40___QOmuP`,
	"mT2": `CurieAISidebar-module__m-t-2___X3YHd`,
	"mT3": `CurieAISidebar-module__m-t-3___AtPbr`,
	"mT4": `CurieAISidebar-module__m-t-4___dzoE4`,
	"mT5": `CurieAISidebar-module__m-t-5___PBhml`,
	"mT8": `CurieAISidebar-module__m-t-8___nZT9I`,
	"mT10": `CurieAISidebar-module__m-t-10___x3Mxp`,
	"mT15": `CurieAISidebar-module__m-t-15___gOJc2`,
	"mT16": `CurieAISidebar-module__m-t-16___s_ksB`,
	"mT20": `CurieAISidebar-module__m-t-20___OpPUq`,
	"mT22": `CurieAISidebar-module__m-t-22___YKn3b`,
	"mT30": `CurieAISidebar-module__m-t-30___r_s96`,
	"mT32": `CurieAISidebar-module__m-t-32___U8oDK`,
	"mLAuto": `CurieAISidebar-module__m-l-auto___xwSeC`,
	"mL4": `CurieAISidebar-module__m-l-4___kDvBo`,
	"mL5": `CurieAISidebar-module__m-l-5___akXc1`,
	"mL6": `CurieAISidebar-module__m-l-6___BwQg5`,
	"mL8": `CurieAISidebar-module__m-l-8___N3I5X`,
	"mL10": `CurieAISidebar-module__m-l-10___mOx2D`,
	"mL16": `CurieAISidebar-module__m-l-16___Fem2L`,
	"mL20": `CurieAISidebar-module__m-l-20___a8SOQ`,
	"mL24": `CurieAISidebar-module__m-l-24___NqrtV`,
	"mL30": `CurieAISidebar-module__m-l-30___t6Gql`,
	"mL35": `CurieAISidebar-module__m-l-35___ZEVE8`,
	"mL40": `CurieAISidebar-module__m-l-40___r1rsh`,
	"mR8": `CurieAISidebar-module__m-r-8___VeE78`,
	"mR10": `CurieAISidebar-module__m-r-10___xKDgo`,
	"mR16": `CurieAISidebar-module__m-r-16___JC6GZ`,
	"mR20": `CurieAISidebar-module__m-r-20___GJrz2`,
	"mR24": `CurieAISidebar-module__m-r-24___zkCw5`,
	"mR30": `CurieAISidebar-module__m-r-30___urNoF`,
	"mR40": `CurieAISidebar-module__m-r-40___AgcSR`,
	"borderR3": `CurieAISidebar-module__border-r-3___uvwen`,
	"borderR4": `CurieAISidebar-module__border-r-4___dSFWv`,
	"borderR6": `CurieAISidebar-module__border-r-6___PlzZL`,
	"borderR10": `CurieAISidebar-module__border-r-10___FiRV8`,
	"borderR12": `CurieAISidebar-module__border-r-12___Jg3g4`,
	"borderR16": `CurieAISidebar-module__border-r-16___YKLzh`,
	"borderR50": `CurieAISidebar-module__border-r-50___xC5wo`,
	"primaryBorder": `CurieAISidebar-module__primary-border___m0FAA`,
	"primaryBorderB": `CurieAISidebar-module__primary-border-b___wRliW`,
	"primaryBorderT": `CurieAISidebar-module__primary-border-t___dJt1s`,
	"primaryBorderL": `CurieAISidebar-module__primary-border-l___RofYa`,
	"primaryBorderR": `CurieAISidebar-module__primary-border-r___MM_cW`,
	"secondaryBorder": `CurieAISidebar-module__secondary-border___OK7ki`,
	"secondaryBorderB": `CurieAISidebar-module__secondary-border-b___NUOhz`,
	"secondaryBorderT": `CurieAISidebar-module__secondary-border-t___l0hAx`,
	"secondaryBorderL": `CurieAISidebar-module__secondary-border-l___kG3BZ`,
	"secondaryBorderR": `CurieAISidebar-module__secondary-border-r___VTWxj`,
	"gap0": `CurieAISidebar-module__gap-0___nbaTc`,
	"gap2": `CurieAISidebar-module__gap-2___CfNj_`,
	"gap4": `CurieAISidebar-module__gap-4___UOeep`,
	"gap5": `CurieAISidebar-module__gap-5___E_YOV`,
	"gap6": `CurieAISidebar-module__gap-6___Y6c89`,
	"gap8": `CurieAISidebar-module__gap-8___FCHvA`,
	"gap10": `CurieAISidebar-module__gap-10___UnwAn`,
	"gap12": `CurieAISidebar-module__gap-12___hZZIL`,
	"gap14": `CurieAISidebar-module__gap-14___nrGsS`,
	"gap16": `CurieAISidebar-module__gap-16___EsIV1`,
	"gap18": `CurieAISidebar-module__gap-18___Qf2gl`,
	"gap20": `CurieAISidebar-module__gap-20___wlP4y`,
	"gap24": `CurieAISidebar-module__gap-24___KtuPX`,
	"gap26": `CurieAISidebar-module__gap-26___s7Okk`,
	"gap30": `CurieAISidebar-module__gap-30___NmNJ4`,
	"gap32": `CurieAISidebar-module__gap-32___ZbmKU`,
	"gap40": `CurieAISidebar-module__gap-40___ufcG5`,
	"gap50": `CurieAISidebar-module__gap-50___QKt72`,
	"flex1": `CurieAISidebar-module__flex-1___jDZxh`,
	"flexNone": `CurieAISidebar-module__flex-none___osX74`,
	"flexColumn": `CurieAISidebar-module__flex-column___dBWky`,
	"flexRow": `CurieAISidebar-module__flex-row___McZUe`,
	"verticallyCentered": `CurieAISidebar-module__vertically-centered___H9foy`,
	"horizontallyCentered": `CurieAISidebar-module__horizontally-centered___swSuJ`,
	"horizontallyEnd": `CurieAISidebar-module__horizontally-end___nBKhE`,
	"verticallyStart": `CurieAISidebar-module__vertically-start___gPT7d`,
	"spaceBetween": `CurieAISidebar-module__space-between___RJvQz`,
	"flexWrap": `CurieAISidebar-module__flex-wrap___LHZQZ`,
	"height100": `CurieAISidebar-module__height-100___rKLtA`,
	"width50": `CurieAISidebar-module__width-50___Jmo2g`,
	"width100": `CurieAISidebar-module__width-100___QIX4U`,
	"cursorPointer": `CurieAISidebar-module__cursor-pointer___r0QGH`,
	"cursorNotAllowed": `CurieAISidebar-module__cursor-not-allowed___Ax9gl`,
	"absoluteCentered": `CurieAISidebar-module__absolute-centered___XlHY0`,
	"absolute": `CurieAISidebar-module__absolute___imaRQ`,
	"relative": `CurieAISidebar-module__relative___ZlVBu`,
	"fixed": `CurieAISidebar-module__fixed___KDtzL`,
	"visible": `CurieAISidebar-module__visible___WOftn`,
	"invisible": `CurieAISidebar-module__invisible___J_vbO`,
	"col90": `CurieAISidebar-module__col-90___Fm6PC`,
	"colAuto": `CurieAISidebar-module__col-auto___R7iO8`,
	"medicalTabs": `CurieAISidebar-module__medical-tabs___r70k5`,
	"medicalTableNew": `CurieAISidebar-module__medical-table-new___qCxlq`,
	"noPagination": `CurieAISidebar-module__no-pagination___G7dsH`,
	"medicalTableEmpty": `CurieAISidebar-module__medical-table-empty___WxUv9`,
	"iconBtn": `CurieAISidebar-module__icon-btn___JPL23`,
	"searchIcon": `CurieAISidebar-module__search-icon___bLXLh`,
	"disableSelect": `CurieAISidebar-module__disable-select___zyVR5`,
	"breakWord": `CurieAISidebar-module__break-word___PaUCK`,
	"popupClearBtn": `CurieAISidebar-module__popup-clear-btn___m6xzw`,
	"scrollMB20": `CurieAISidebar-module__scroll-m-b-20___oIOO_`,
	"list": `CurieAISidebar-module__list___A0YMo`,
	"emptyText": `CurieAISidebar-module__emptyText___Dt0iu`
};
module.exports = ___CSS_LOADER_EXPORT___;
